module.exports = __webpack_public_path__ + "img/img01.bdca8b77.png";